import { to } from 'await-to-js';
import { getToken, removeToken, setToken } from '@/utils/auth';
import { login as loginApi, logout as logoutApi, getInfo as getUserInfo } from '@/api/login';
import { LoginData } from '@/api/types';
import defAva from '@/assets/images/profile.jpg';
import store from '@/store';
import moment from 'moment';

// const { proxy } = getCurrentInstance() as ComponentInternalInstance;
import { ElMessage, ElMessageBox } from 'element-plus'
export const useUserStore = defineStore('user', () => {
  const token = ref(getToken());
  const name = ref('');
  const phonenumber = ref('');
  const nickname = ref('');
  const idCard = ref(''); //身份证号 用于判断是否已经维护个人信息
  const userId = ref<string | number>('');
  const tenantId = ref<string>('');
  const avatar = ref('');
  const schoolDeptId = ref('');
  const scoreFlag = ref('');
  const groupId = ref('');
  const roles = ref<Array<string>>([]); // 用户角色编码集合 → 判断路由权限
  const permissions = ref<Array<string>>([]); // 用户权限编码集合 → 判断按钮权限

  /**
   * 登录
   * @param userInfo
   * @returns
   */
  const login = async (userInfo: LoginData): Promise<void> => {
    const [err, res] = await to(loginApi(userInfo));
    if (res) {
      const data = res.data;
      setToken(data.access_token);
      token.value = data.access_token;
      return Promise.resolve();
    }
    return Promise.reject(err);
  };

  // 获取用户信息
  const getInfo = async (): Promise<void> => {
    const [err, res] = await to(getUserInfo());
    if (res) {
      const data = res.data;
      const user = data.user;
      console.log('useee',user);
      
      const profile = user.avatar == '' || user.avatar == null ? defAva : user.avatar;

      if (data.roles && data.roles.length > 0) {
        // 验证返回的roles是否是一个非空数组
        roles.value = data.roles;
        permissions.value = data.permissions;
      } else {
        roles.value = ['ROLE_DEFAULT'];
      }
      name.value = user.userName;
      nickname.value = user.nickName;
      phonenumber.value = user.phonenumber;
      avatar.value = profile;
      userId.value = user.userId;
      tenantId.value = user.tenantId;
      idCard.value = user.idCard;
      schoolDeptId.value = user.deptId;
      scoreFlag.value = user.scoreFlag;
      groupId.value = user.groupId;
      return Promise.resolve();
    }
    return Promise.reject(err);
  };

  // 注销
  const logout = async (): Promise<void> => {
    await logoutApi();
    token.value = '';
    roles.value = [];
    permissions.value = [];
    removeToken();
  };

//判断是否已经维护个人信息 有返回true 没有弹窗提示
// 获取router实例
const router = useRouter();
const isHasIdCard =  async () => {
    if(!idCard.value ){
      let msg = !!token.value?"请先维护个人信息后，再继续操作！":"请登录后，再继续操作！"
    return  ElMessageBox.alert(msg, '系统提示', {
        confirmButtonText: '前往',
        confirmButtonClass: 'button_style',
        callback: (action) => {
          if(action=='confirm'){
            router.push({ path: '/baseInfo'});
          }
        },
      })
    }else{
      return true;
    }
 
};

// 判断当前时间是否在指定的开始和结束时间内
const isCurrentTimeInRange = (startTime: string, endTime: string): boolean => {
  const now = moment(); // 获取当前时间
  const start = moment(startTime); // 解析开始时间
  const end = moment(endTime); // 解析结束时间

  // 判断当前时间是否在开始时间和结束时间之间
  return now.isBetween(start, end);
};

// 判断当前活动是否在有效期内
 const withinValidTime = async( item ) => {
     return  isCurrentTimeInRange(item.startTime, item.endTime);
  // const now = new Date().getTime();
  // const expire = new Date(localStorage.getItem('expire')).getTime();
  // return now < expire;
};




  const setAvatar = (value: string) => {
    avatar.value = value;
  };

  return {
    userId,
    tenantId,
    token,
    nickname,
    name,
    scoreFlag,
    groupId,
    phonenumber,
    avatar,
    roles,
    permissions,
    idCard,
    login,
    getInfo,
    logout,
    setAvatar,
    isHasIdCard,
    schoolDeptId,
    withinValidTime
  };
});

export default useUserStore;
// 非setup
export function useUserStoreHook() {
  return useUserStore(store);
}
